import * as React from 'react';
import { hydrateRoot } from 'react-dom/client';
import CategoryPage from './categorypage/categorypage';

function hydrateCategoryPage() {
    if (typeof window.__PRELOADED_CATEGORY_PAGE_STATE__ !== 'undefined') {
        const data = JSON.parse(JSON.stringify(window.__PRELOADED_CATEGORY_PAGE_STATE__));
        delete window.__PRELOADED_CATEGORY_PAGE_STATE__;
        hydrateRoot(
            document.getElementById('ats-categorypage'),
            <CategoryPage {...data} suppressHydrationWarning />,
        );
    }
}

hydrateCategoryPage();
